import { Box } from '@collinsonx/design-system/core';
import useLocale from 'hooks/useLocale';
import { FC } from 'react';
import { replaceTranslationPlaceholder } from 'utils/translations';

interface Props {
  hours: number;
}

const MinPeriodMessage: FC<Props> = ({ hours }) => {
  const translations = useLocale();

  return (
    <Box>
      {replaceTranslationPlaceholder(
        translations.lounge.errors.minPeriod.description,
        { hours }
      )}
    </Box>
  );
};

export default MinPeriodMessage;
